import { Box } from '@chakra-ui/react'
import { FC } from 'react'
import { Helmet } from 'react-helmet'

import BackgroundTasks from '@component/BackgroundTasks'

import LayoutHeader from './Header'

interface ILayoutProps {
  title: string
  withBackdroundDrop?: boolean
}

const Layout: FC<ILayoutProps> = ({
  title,
  withBackdroundDrop = false,
  children
}) => {
  // useEffect(() => {
  //   ;(async function () {
  //     try {
  //       const fetchData = async () => {
  //         // get the data from the api
  //         console.log('test')
  //         await generic
  //           .getMaintence('manutencao')
  //           .then(({ data: { data } }) => {
  //             if (data.valor === 'true') {
  //               window.location.href = '/manutencao'
  //             }
  //           })
  //           .catch(() => {})
  //       }
  //       fetchData()
  //     } catch (e) {
  //       console.error(e)
  //     }
  //   })()
  // }, [])
  return (
    <Box bg="white" h="100vh" overflowY="auto" color="gray.800">
      <Helmet>
        <title>{title} - SCL</title>
      </Helmet>
      <LayoutHeader />
      {withBackdroundDrop ? (
        <>
          <Box
            pos="relative"
            bgColor="#1d5840"
            h="90px"
            mt="-1px"
            borderTop="solid 1px"
            borderColor="rgba(255, 255, 255, 0.1)"
            zIndex={2}
          />
          <Box pos="relative" mt="-96px" zIndex={3}>
            {children}
          </Box>
        </>
      ) : (
        children
      )}
      <BackgroundTasks />
    </Box>
  )
}

export default Layout
